import React from "react";
import { Link } from "@hid-galaxy-ui/galaxy-react";

type ActivityDescriptionLinkProps = {
  description?: string;
  activityName?: string;
  onView: (payload: { activityName?: string; description?: string }) => void;
};

const ActivityDescriptionLink: React.FC<ActivityDescriptionLinkProps> = ({
  description,
  activityName,
  onView,
}) => {
  const hasDescription = Boolean(description?.trim());

  if (!hasDescription) {
    return <span className="t-center">-</span>;
  }

  return (
    <Link
      onClick={(e) => {
        e.stopPropagation();
        onView({ activityName, description });
      }}
    >
      View
    </Link>
  );
};

export default ActivityDescriptionLink;
